import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props} from './types';

import {Clickable} from '../../uikit/Clickable';
import {useController} from './controller';
import {ButtonText, Container, Text} from './styles';

const ResendCodeButton: FC<Props> = props => {
  const {remainSec} = useController(props);

  const {disabled, onClick, resendTextColor, ...rest} = props;

  const {t} = useI18n();

  return (
    <Container {...rest} disabled={disabled}>
      {remainSec > 0 ? (
        <Text color={resendTextColor ?? 'text.gray'}>
          {t('shared:resend_code_timer', {
            count: remainSec,
          })}
        </Text>
      ) : (
        <Clickable onClick={disabled ? undefined : onClick}>
          <ButtonText>{t('shared:resend_code')}</ButtonText>
        </Clickable>
      )}
    </Container>
  );
};

export {ResendCodeButton};
